'use client';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import styled, { css } from 'styled-components';
import { defaultStyles } from '../../mixins/defaultStyles.js';
import { textStyle } from '../../mixins/textStyle.js';

const ListItemBaseAdornmentWrapper = styled.div.withConfig({
  componentId: "sc-s7563g-0"
})(["display:flex;align-items:center;margin-bottom:auto;position:relative;", " ", " ", ""], ({
  isString
}) => !isString && css(["top:2px;"]), ({
  position,
  theme
}) => position === 'left' && css(["margin-right:", ";"], theme.components.listItem.iconMargin), ({
  position,
  theme
}) => position === 'right' && css(["align-self:flex-end;margin-left:", ";"], theme.components.listItem.iconMargin));
const ListItemBaseLi = styled.li.withConfig({
  componentId: "sc-s7563g-1"
})(["", ";", ";", ";color:", ";display:flex;flex-direction:row;align-items:flex-start;&:focus{outline:none;}&[disabled]{cursor:not-allowed;color:", ";}", ""], defaultStyles.fontSmoothing, defaultStyles.boxSizing, textStyle('label'), ({
  theme
}) => theme.components.listItem.textColor, ({
  theme
}) => theme.components.listItem.textColorDisabled, ({
  onClick
}) => onClick && css(["cursor:pointer;"]));
const StyledSpan = styled('span').withConfig({
  componentId: "sc-s7563g-2"
})(["flex:1;"]);
const ListItemBaseInnerWrapper = ({
  children,
  prefixAdornment,
  suffixAdornment
}) => jsxs(Fragment, {
  children: [prefixAdornment && jsx(ListItemBaseAdornmentWrapper, {
    isString: typeof prefixAdornment === 'string',
    position: "left",
    children: prefixAdornment
  }), jsx(StyledSpan, {
    children: children
  }), suffixAdornment && jsx(ListItemBaseAdornmentWrapper, {
    isString: typeof suffixAdornment === 'string',
    position: "right",
    children: suffixAdornment
  })]
});

export { ListItemBaseInnerWrapper, ListItemBaseLi };
//# sourceMappingURL=ListItemBase.js.map
